import React from 'react';

export default function ({ color = '#ffffff', size = 15 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7.99998C3.76099 7.99998 5.99998 5.76099 5.99998 3C5.99998 5.76099 8.23898 7.99998 11 7.99998"
        fill={color}
      />
      <path
        d="M1 7.99998C3.76099 7.99998 5.99998 5.76099 5.99998 3C5.99998 5.76099 8.23898 7.99998 11 7.99998"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 8C3.76099 8 5.99998 10.239 5.99998 13C5.99998 10.239 8.23898 8 11 8"
        fill="white"
      />
      <path
        d="M1 8C3.76099 8 5.99998 10.239 5.99998 13C5.99998 10.239 8.23898 8 11 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 3.74999C12.2412 3.74999 12.0312 3.53999 12.0312 3.28124C12.0312 2.76374 11.6112 2.34374 11.0937 2.34374C10.835 2.34374 10.625 2.13374 10.625 1.87499C10.625 1.61625 10.835 1.40625 11.0937 1.40625C11.6112 1.40625 12.0312 0.986247 12.0312 0.468749C12.0312 0.209999 12.2412 0 12.5 0C12.7587 0 12.9687 0.209999 12.9687 0.468749C12.9687 0.986247 13.3887 1.40625 13.9062 1.40625C14.165 1.40625 14.375 1.61625 14.375 1.87499C14.375 2.13374 14.165 2.34374 13.9062 2.34374C13.3887 2.34374 12.9687 2.76374 12.9687 3.28124C12.9687 3.53999 12.7587 3.74999 12.5 3.74999Z"
        fill={color}
      />
    </svg>
  );
}
